import fetch from "isomorphic-fetch";
import _ from "lodash";
import {
	API2_URL,
	PROJECT_OWNER,
	PROJECT_FAIL,
	PROJECT_REQUEST,
	PROJECT_CLEAR,
	PROJECT_INSTANCE,
	PROJECT_EMPLOYEES,
	PROJECT_CONCLUSION,
	PROJECT_EMPLOYEES_REQUEST,
	PROJECT_EMPLOYEES_EDIT_REQUEST,
	PROJECT_EMPLOYEES_FAIL,
	PROJECT_OWNER_REQUEST,
	PROJECT_OWNER_FAIL,
	PROJECT_CONCLUSION_REQUEST,
	PROJECT_CONCLUSION_LOADED,
	PROJECT_CONCLUSION_FAIL,
	PROJECT_CONCLUSION_CLEAR,
	PROJECT_INSTANCE_FAIL,
	PROJECT_REGISTRY_FAIL,
	PROJECT_OWNER_CLEAR,
	PROJECT_INSTANCE_REQUEST,
	PROJECT_INSTANCE_LOADED,
	PROJECT_INSTANCE_CLEAR,
	PROJECT_LOADED,
	PROJECT_EMPLOYEES_CLEAR,
	PROJECT_REGISTRY_DATA_REQUEST,
	PROJECT_REGISTRY_DATA_FAIL,
	PROJECT_REGISTRY_DATA,
	PROJECT_REGISTRY_REQUEST,
	PROJECT_REGISTRY_LOADED,
	PROJECT_REGISTRY_CLEAR,
	PROJECT_PROIGUALDAD_GOALS_REQUEST,
	PROJECT_PROIGUALDAD_GOALS_COMPLETE,
	PROJECT_PROIGUALDAD_GOALS,
	PROJECT_PROIGUALDAD_GOALS_EDIT,
	PROJECT_PROIGUALDAD_GOALS_CLEAR,
	PROJECT_PROIGUALDAD_GOALS_FAIL,
	/*PROJECT_AGREEMENTS_ADMIN,
	PROJECT_AGREEMENTS_LEGAL,
	PROJECT_AGREEMENTS_REQUEST,
	PROJECT_AGREEMENTS_ADMIN_REQUEST,
	PROJECT_AGREEMENTS_LEGAL_REQUEST,
	PROJECT_AGREEMENTS_CLEAR,
	PROJECT_AGREEMENTS_FAIL,
	PROJECT_AGREEMENTS_ADMIN_FAIL,
	PROJECT_AGREEMENTS_LEGAL_FAIL,
	PROJECT_AGREEMENTS_LOADED,
	PROJECT_DISPERSIONS,
	PROJECT_DISPERSIONS_REQUEST,
	PROJECT_DISPERSIONS_LOADED,
	PROJECT_DISPERSIONS_CLEAR,
	PROJECT_DISPERSIONS_FAIL,*/
	PROJECT_EXPENSES_CLEAR,
	PROJECT_EXPENSES, PROJECT_EXPENSES_REQUEST, PROJECT_EXPENSES_FAIL
} from "../store/config";
import {newNotification} from "./notifications";
import {sessionService} from 'redux-react-session';
import {goalsList} from "./goals";
import {actorsList} from "./directories";
import {conagoList} from "./directories";
import {resourceConceptsList} from "./resource_concept";
import {entitiesList} from "./entities";
import {modalitiesList} from "./modalities";
import {conceptsList} from "./concepts";
import FileSaver from "file-saver";
import {axisList} from "./axis";
import {linesList} from "./lines";
import {activitiesList} from "./activities";
import {municipalitiesList} from "./municipalities";
import {history} from "../store/store";

/* project owner */
export const projectOwner = (modality, state, mun = undefined) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			dispatch(projectOwnerRequest());
			dispatch(projectOwnerClear());
			return fetch(`${API2_URL}/projects/register/owner/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(projectOwnerData(json)),
					error => {
						dispatch(newNotification({
							title: '¡Oh no!',
							content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error),
							type: 'danger'
						}))
						return dispatch(projectOwnerFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
					}
				)
		})
}

export const projectOwnerSave = (modality, state, mun = undefined, data, event) => {

	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				let body = new FormData(event);

				_.mapKeys(data, (o, j) => {
					if (o !== undefined) {
						if (!_.isObject(o) && !_.startsWith(o, 'http://')) {
							body.append(j, o);
						} else if (_.isObject(o) && !_.isEmpty(o) && o[0] !== undefined) {
							body.append(j, o[0]);
						}
					}
				});

				const options = {
					headers: {
						'Accept': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: body
				};

				dispatch(projectOwnerRequest());
				return fetch(`${API2_URL}/projects/register/owner/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({
								title: "¡Éxito!",
								content: json.message ? json.message : "La información del titular se ha guardado correctamente",
								type: "success"
							}))
							return dispatch(projectOwnerData(json));
						},
						error => {
							dispatch(newNotification({
								title: "¡Oh no!",
								content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error),
								type: "danger"
							}));
							return dispatch(projectOwnerFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
						}
					);
			})
	}
}

const projectOwnerData = (json) => {
	let documents = {};
	let data = {};

	if (json.data) {
		_.mapKeys(json.data, (item, key) => {
			data = {
				...data,
				[key]: item ? item : undefined
			}
		})

		if (!_.isEmpty(json.data.documents)) {
			_.map(json.data.documents, (item) => {
				documents = {
					...documents,
					[item.documentable_subtype]: item.file
				}
			})
		}
	}

	return {
		type: PROJECT_OWNER,
		isFetching: false,
		payload: {
			...data,
			...documents
		},
		documents_items: json.documents_items,
		editable: json.editable,
		revision: json.revision ? {
			...json.revision,
			body: JSON.parse(json.revision.body)
		} : {},
		permissions: json.permissions,
		phase: json.phase,
		version: json.version,
		timestamp: Date.now()
	}
}

const projectOwnerRequest = () => {
	return {
		type: PROJECT_OWNER_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const projectOwnerFail = (error) => {
	return {
		type: PROJECT_OWNER_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
}

const projectOwnerClear = () => {
	return {
		type: PROJECT_OWNER_CLEAR,
		payload: {},
		timestamp: Date.now()
	}
}

/* project instance */
export const projectAgency = (modality, state, mun = undefined) => (dispatch) => {
	dispatch(projectAgencyRequest());
	dispatch(projectAgencyClear());
	dispatch(entitiesList())

	return dispatch(modalitiesList())
		.then(modalities => {
			if (!_.isEmpty(modalities.payload)) {
				return dispatch(projectOwner(modality, state, mun))
					.then(owner => {
						if (_.isObject(owner.payload) || !_.isEmpty(owner.payload)) {
							return dispatch(fetchProjectAgency(modality, state, mun))
								.then(agency => {
									if (!_.isEmpty(agency.payload)) {
										dispatch(municipalitiesList(agency.payload.state_id))
									}
								})
						} else {
							return dispatch(projectAgencyFail('Carga de instancia incompleta'))
						}
					})
			} else {
				return dispatch(projectAgencyFail('Carga de instancia incompleta'))
			}
		})
}

export const fetchProjectAgency = (modality, state, mun = undefined) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			return fetch(`${API2_URL}/projects/register/agency/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(projectAgencyData(json)),
					error => {
						dispatch(newNotification({
							title: '¡Oh no!',
							content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error),
							type: 'danger'
						}))
						return dispatch(projectAgencyFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)))
					}
				)
		})
}

export const projectAgencyExport = (modality, state, mun = undefined) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};
				let fileName = undefined;
				dispatch(projectAgencyRequest());
				return fetch(`${API2_URL}/projects/register/agency/participation-request-pdf/${modality}/${state}${mun ? '/' + mun : ''}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							let header = result.headers.get('Content-Disposition', 'attachment')
							fileName = header.match(/filename="(.+)"/)[1];
							return result.blob();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						blob => {
							FileSaver.saveAs(blob, fileName);
							dispatch(projectAgencyLoaded())
						},
						error => {
							dispatch(newNotification({
								title: '¡Oh no!',
								content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error),
								type: 'danger'
							}))
							return dispatch(projectAgencyFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)))
						}
					)
			})
	}
}

export const projectAgencySave = (modality, state, mun = undefined, data) => {

	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				dispatch(projectAgencyRequest());
				let body = new FormData();

				_.mapKeys(data, (o, j) => {
					if (o !== undefined) {
						if (!_.isObject(o) && !_.startsWith(o, 'http://')) {
							body.append(j, o);
						} else if (_.isObject(o) && !_.isEmpty(o) && o[0] !== undefined) {
							body.append(j, o[0]);
						}
					}
				});

				const options = {
					headers: {
						'Accept': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: body
				};

				//dispatch(projectRequest());
				return fetch(`${API2_URL}/projects/register/agency/${modality}/${state}${mun !== undefined ? '/' + mun : ''}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({
								title: "¡Éxito!",
								content: "La información de la instancia se ha guardado correctamente",
								type: "success"
							}))
							return dispatch(projectAgencyData(json));
						},
						error => {
							dispatch(newNotification({
								title: "¡Oh no!",
								content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error),
								type: "danger"
							}));
							return dispatch(projectFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
						}
					);
			})
	}
}

const projectAgencyData = (json) => {
	let documents = {};
	let data = {};

	if (json.data) {
		_.mapKeys(json.data, (item, key) => {
			data = {
				...data,
				[key]: item ? item : undefined
			};
		})

		data = {
			...data,
			state_id: !_.isEmpty(json.data.municipality) ? json.data.municipality.state_id : undefined
		};

		if (!_.isEmpty(json.data.documents)) {
			_.map(json.data.documents, (item) => {
				documents = {
					...documents,
					[item.documentable_subtype]: item.file
				}
			})
		}
	}

	return {
		type: PROJECT_INSTANCE,
		isFetching: false,
		payload: {
			...data,
			...documents
		},
		documents_items: json.documents_items,
		editable: json.editable,
		revision: json.revision ? {
			...json.revision,
			body: JSON.parse(json.revision.body)
		} : {},
		phase: json.phase,
		version: json.version,
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const projectAgencyRequest = () => {
	return {
		type: PROJECT_INSTANCE_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const projectAgencyLoaded = () => {
	return {
		type: PROJECT_INSTANCE_LOADED,
		isFetching: false,
		timestamp: Date.now()
	}
}

const projectAgencyFail = (error) => {
	return {
		type: PROJECT_INSTANCE_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
}

const projectAgencyClear = () => {
	return {
		type: PROJECT_INSTANCE_CLEAR,
		payload: {},
		timestamp: Date.now()
	}
}

/* project registry */
export const projectRegistry = (modality, state, mun = undefined) => (dispatch) => {

	dispatch(projectRegistryRequest());
	dispatch(projectRegistryClear());
	dispatch(entitiesList());

	return dispatch(actorsList())
		.then((actors) => {
			if (!_.isEmpty(actors.payload)) {
				return dispatch(conagoList())
					.then((conago) => {
						if (!_.isEmpty(conago.payload)) {
							return dispatch(resourceConceptsList())
								.then((resources) => {
									if (!_.isEmpty(resources.payload)) {
										return dispatch(projectRegistryData(modality, state, mun/*, goals.payload*/))
											.then(registry => {
												let modality = !_.isEmpty(registry.payload) && registry.payload.modality_id ? registry.payload.modality_id : undefined;
												let agenciable = !_.isEmpty(registry.payload) && registry.payload.agency && registry.payload.agency.agenciable_id ? registry.payload.agency.agenciable_id : undefined;
												if (!_.isEmpty(registry.payload)) {
													return dispatch(goalsList(modality, agenciable))
														.then(goals => {
															if (!_.isEmpty(goals.payload)) {
																return dispatch(projectRegistryLoaded());
															} else {
																return dispatch(projectRegistryFail('Carga de registro incompleta'))
															}
														})
												} else {
													return dispatch(projectRegistryFail('Carga de registro incompleta'))
												}
											})
									} else {
										return dispatch(projectRegistryFail('Carga de registro incompleta'))
									}
								})
						} else {
							return dispatch(projectRegistryFail('Carga de registro incompleta'))
						}
					})
			} else {
				return dispatch(projectRegistryFail('Carga de registro incompleta'))
			}
		})
}

const projectRegistryRequest = () => {
	return {
		type: PROJECT_REGISTRY_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const projectRegistryFail = (error) => {
	return {
		type: PROJECT_REGISTRY_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
}

const projectRegistryLoaded = () => {
	return {
		type: PROJECT_REGISTRY_LOADED,
		isFetching: false,
		payload: true,
		timestamp: Date.now()
	}
}

const projectRegistryClear = () => {
	return {
		type: PROJECT_REGISTRY_CLEAR,
		payload: {
			isFetching: false,
			error: undefined,
			project_goals: [],
			amounts: {}
		},
		timestamp: Date.now()
	}
}


/* project registry data */
export const projectRegistryData = (modality, state, mun = undefined/*, goals*/) => {

	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				}

				dispatch(projectRegistryDataRequest());
				return fetch(`${API2_URL}/projects/register/project/${modality}/${state}${mun ? '/' + mun : ''}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(projectRegistryDataInfo(json/*, goals*/)),
						error => {
							dispatch(newNotification({
								title: '¡Oh no!',
								content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error),
								type: 'danger'
							}));
							return dispatch(projectRegistryDataFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
						}
					)
			})
	}
}

export const projectRegistrySave = (modality, state, mun = undefined, data) => (dispatch) => {
	dispatch(projectRegistryRequest());
	return dispatch(projectRegistryEditSave(modality, state, mun, data))
		.then((registry) => {
			if (!_.isEmpty(registry.payload)) {
				return dispatch(projectRegistryLoaded());
			} else {
				return dispatch(projectRegistryFail(registry.error))
			}
		})
}

const projectRegistryEditSave = (modality, state, mun = undefined, data) => {

	const newData = {
		execution_end: data.execution_end,
		execution_start: data.execution_start,
		id: data.id,
		justification: data.justification,
		modality_id: data.modality_id,
		name: data.name,
		objective: data.objective,
		status_id: data.status_id,
		goals: _.map(data.project_goals, (goal) => {
			return {
				geographic_area: goal.geographic_area,
				goal_document: goal.goal_document,
				id: goal.id,
				is_continuing: goal.is_continuing,
				line_id: goal.line_id,
				mandatory: goal.mandatory,
				proigualdad_goal_id: goal.proigualdad_goal_id,
				project_id: goal.project_id,
				total: goal.total,
				actors: goal.actors,
				resource_concept_id: goal.resource_concept_id,
				conago_clauses: goal.conago_clauses,
				municipalities: _.map(goal.agencies, (mun) => { return {id: mun.agenciable_id}}),
				activities: [...goal.project_goal_activities]

			}
		})
	}

	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: JSON.stringify(newData)
				}

				dispatch(projectRegistryDataRequest());
				return fetch(`${API2_URL}/projects/register/project/${modality}/${state}${mun ? '/' + mun : ''}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({
								title: '¡Éxito!',
								content: json.message ? json.message : 'Se guardaron correctamente los cambios',
								type: 'success'
							}));
							return dispatch(projectRegistryDataInfo(json))
						},
						error => {
							dispatch(newNotification({
								title: '¡Oh no!',
								content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error),
								type: 'danger'
							}));
							return dispatch(projectRegistryDataFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
						}
					)
			})
	}
}

const projectRegistryDataRequest = () => {
	return {
		type: PROJECT_REGISTRY_DATA_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const projectRegistryDataInfo = (json) => {
	let data = json.data;
	let revisions = [];
	let total = 0;

	if (!_.isEmpty(json.data)) {
		_.map(json.data.project_goals, (item) => total += item.amounts.total);
	}

	if (!_.isEmpty(json.revisions)) {
		_.map(json.revisions, (item) => {
			revisions.push({
				...item,
				body: JSON.parse(item.body)
			})
		})
	}

	return {
		type: PROJECT_REGISTRY_DATA,
		isFetching: false,
		payload: {
			...data,
			amounts: total
		},
		documents_items: json.documents_items,
		editable: json.editable,
		revision: json.revision ? {
			...json.revision,
			body: JSON.parse(json.revision.body)
		} : {},
		revisions: revisions,
		phase: json.phase,
		version: json.version,
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const projectRegistryDataFail = (error) => {
	return {
		type: PROJECT_REGISTRY_DATA_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
}

/*Project registry goals proigualdad*/
export const projectProigualdadGoals = (page = 1, modality, state, mun = undefined) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			}

			dispatch(projectProigualdadGoalsRequest())
			return fetch(`${API2_URL}/projects/register/proigualdad-goals/project/${modality}/${state}${mun ? '/' + mun : ''}?page=${page}&per_page=10`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(projectProigualdadGoalsData(json)),
					error => {
						dispatch(newNotification({
							title: '¡Oh no!',
							content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error),
							type: 'danger'
						}));
						return dispatch(projectProigualdadGoalsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
					}
				)
		})
}

export const projectProigualdadGoalsEdit = (goal, modality, state, mun = undefined) => (dispatch) => {
	dispatch(projectProigualdadGoalsRequest())
	dispatch(projectProigualdadGoalsEditClear())

	return dispatch(axisList(1))
		.then((axis) => {
			if (!_.isEmpty(axis.payload)) {
				return dispatch(linesList(1))
					.then((lines) => {
						if (!_.isEmpty(lines.payload)) {
							return dispatch(activitiesList())
								.then((activities) => {
									if (!_.isEmpty(activities.payload)) {
										if (goal) {
											return dispatch(fetchProjectProigualdadGoalsEdit(goal, modality, state, mun))
										} else {
											return dispatch(projectProigualdadGoalsComplete())
										}
									} else {
										return dispatch(projectProigualdadGoalsFail('Carga incompleta'))
									}
								})
						} else {
							return dispatch(projectProigualdadGoalsFail('Carga incompleta'))
						}
					})
			} else {
				return dispatch(projectProigualdadGoalsFail('Carga incompleta'))
			}
		})
}

const fetchProjectProigualdadGoalsEdit = (goal, modality, state, mun = undefined) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			}

			dispatch(projectProigualdadGoalsRequest())
			return fetch(`${API2_URL}/projects/register/proigualdad-goals/${goal}/project/${modality}/${state}${mun ? '/' + mun : ''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(projectProigualdadGoalsEditData(json)),
					error => {
						dispatch(newNotification({
							title: '¡Oh no!',
							content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error),
							type: 'danger'
						}));
						return dispatch(projectProigualdadGoalsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
					}
				)
		})
}

export const projectProigualdadGoalsEditSave = (goal = undefined, modality, state, mun = undefined, values) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				body: JSON.stringify(values)
			}

			dispatch(projectProigualdadGoalsRequest())
			return fetch(`${API2_URL}/projects/register/proigualdad-goals${goal ? `/${goal}` : ''}/project/${modality}/${state}${mun ? '/' + mun : ''}${goal ? '?_method=PUT' : ''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({
							title: '¡Éxito!',
							content: json.message ? json.message : 'Se guardaron correctamente los cambios',
							type: 'success'
						}));
						if (_.isEmpty(goal)) {
							history.push(`/proyecto/${modality}/proigualdad-meta/editar/${json.data.id}/${state}${mun ? '/' + mun : ''}`);
						}
						return dispatch(projectProigualdadGoalsEditData(json))
					},
					error => {
						dispatch(newNotification({
							title: '¡Oh no!',
							content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error),
							type: 'danger'
						}));
						return dispatch(projectProigualdadGoalsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
					}
				)
		})
}

const projectProigualdadGoalsData = (json) => {
	return {
		type: PROJECT_PROIGUALDAD_GOALS,
		isFetching: false,
		payload: json.data,
		pages: {
			current: json.current_page,
			per_page: json.per_page,
			total: json.total
		},
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const projectProigualdadGoalsEditData = (json) => {
	return {
		type: PROJECT_PROIGUALDAD_GOALS_EDIT,
		isFetching: false,
		payload: json.data,
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const projectProigualdadGoalsComplete = () => {
	return {
		type: PROJECT_PROIGUALDAD_GOALS_COMPLETE,
		isFetching: false,
		timestamp: Date.now()
	}
}

const projectProigualdadGoalsRequest = () => {
	return {
		type: PROJECT_PROIGUALDAD_GOALS_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const projectProigualdadGoalsEditClear = () => {
	return {
		type: PROJECT_PROIGUALDAD_GOALS_CLEAR,
		payload: {},
		timestamp: Date.now()
	}
}

const projectProigualdadGoalsFail = (error) => {
	return {
		type: PROJECT_PROIGUALDAD_GOALS_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
}

/*Project Expenses*/

export const projectExpenses = (modality, state, mun = undefined) => (dispatch) => {
	dispatch(projectExpensesRequest());
	dispatch(projectExpensesClear());
	return dispatch(conceptsList())
		.then((concepts) => {
			if (!_.isEmpty(concepts.payload)) {
				return dispatch(fetchProjectExpenses(modality, state, mun))
			}
		})
}

const fetchProjectExpenses = (modality, state, mun = undefined) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			return fetch(`${API2_URL}/projects/register/expenses/${modality}/${state}${mun ? '/' + mun : ''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(projectExpensesData(json)),
					error => {
						dispatch(newNotification({
							title: '¡Oh no!',
							content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error),
							type: "danger"
						}));
						return dispatch(projectExpensesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
					}
				);
		})
}

export const projectExpensesSave = (modality, state, mun = undefined, values) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			dispatch(projectExpensesRequest());
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				body: JSON.stringify({expenses: values.project_expenses})
			};

			return fetch(`${API2_URL}/projects/register/expenses/${modality}/${state}${mun ? '/' + mun : ''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({
							title: "Éxito",
							content: json.message ? json.message : "Los gastos se han guardado correctamente",
							type: "success"
						}));
						return dispatch(projectExpensesData(json))
					},
					error => {
						dispatch(newNotification({
							title: '¡Oh no!',
							content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error),
							type: "danger"
						}));
						return dispatch(projectExpensesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
					}
				);
		})
}

const projectExpensesData = (json) => {
	return {
		type: PROJECT_EXPENSES,
		isFetching: false,
		editable: json.editable,
		payload: json.data,
		revision: json.revision ? {
			...json.revision,
			body: JSON.parse(json.revision.body)
		} : {},
		phase: json.phase,
		version: json.version,
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const projectExpensesRequest = () => {
	return {
		type: PROJECT_EXPENSES_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const projectExpensesClear = () => {
	return {
		type: PROJECT_EXPENSES_CLEAR,
		payload: {},
		timestamp: Date.now()
	}
}

const projectExpensesFail = (error) => {
	return {
		type: PROJECT_EXPENSES_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
}

/* project profiles */
export const projectEmployees = (modality, state, mun = undefined/*, role, agency*/) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			dispatch(projectEmployeeRequest());
			dispatch(projectEmployeesRolesClear());

			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			return fetch(`${API2_URL}/projects/register/employees/${modality}/${state}${mun ? '/' + mun : ''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else if (result.status >= 500) {
						dispatch(newNotification({
							title: '¡Oh no!',
							content: 'Respuesta erronea del servidor',
							type: 'danger'
						}));
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(projectEmployeesData(json)),
					error => {
						dispatch(newNotification({
							title: '¡Oh no!',
							content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error),
							type: "danger"
						}));
						return dispatch(projectEmployeeFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
					}
				)
		})
}

export const projectEmployeeSave = (modality, state, mun = undefined, values) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: JSON.stringify(values)
				};

				dispatch(projectEmployeeEditRequest());
				fetch(`${API2_URL}/projects/register/employees/${modality}/${state}${mun ? '/' + mun : ''}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({
								title: "Éxito",
								content: json.message ? json.message : "El Perfil se ha guardado correctamente",
								type: "success"
							}));
							return dispatch(projectEmployeesData(json));
						},
						error => {
							dispatch(newNotification({
								title: '¡Oh no!',
								content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error),
								type: "danger"
							}));
							return dispatch(projectEmployeeFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
						}
					)
			})
	}
}

const projectEmployeesRolesClear = () => {
	return {
		type: PROJECT_EMPLOYEES_CLEAR,
		payload: {
			data: {
				employees: [],
				roles: [],
			},
			edit: {
				isFetching: false
			}
		},
		phase: {},
		timestamp: Date.now()
	}
}

const projectEmployeesData = (json) => {
	return {
		type: PROJECT_EMPLOYEES,
		isFetching: false,
		editable: json.editable,
		payload: {
			...json.data,
			roles: !_.isEmpty(json.roles) ? json.roles : []
		},
		revision: json.revision ? {
			...json.revision,
			body: JSON.parse(json.revision.body)
		} : {},
		phase: json.phase,
		version: json.version,
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const projectEmployeeRequest = () => {
	return {
		type: PROJECT_EMPLOYEES_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const projectEmployeeEditRequest = () => {
	return {
		type: PROJECT_EMPLOYEES_EDIT_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const projectEmployeeFail = () => {
	return {
		type: PROJECT_EMPLOYEES_FAIL,
		isFetching: false,
		timestamp: Date.now()
	}
}

export const projectClear = () => {
	return {
		type: PROJECT_CLEAR,
		payload: {
			owner: {
				isFetching: false,
				editable: false,
				data: {},
				revision: {},
				documents_items: []
			},
			instance: {
				isFetching: false,
				editable: false,
				data: {},
				list: [],
				revision: {},
				documents_items: []
			},
			registry: {
				isFetching: false,
				editable: false,
				data: {
					isFetching: false,
					error: undefined,
					goals: [],
					amounts: {}
				},
				revision: {},
				revisions: [],
				documents_items: []
			},
			goals: {
				isFetching: false,
				editable: false,
				list: [],
				pages: {
					current: undefined,
					per_page: undefined,
					total: undefined
				},
				edit: {}
			},
			expenses: {
				isFetching: false,
				editable: false,
				edit: {},
				data: {},
				revision: {},
			},
			profiles: {
				isFetching: false,
				editable: false,
				data: {
					employees: [],
					roles: [],
				},
				edit: {
					isFetching: false
				},
				revision: {},
			},
			conclusion: {
				isFetching: false,
				finished: false,
				editable: false,
				data: {},
				revision: {},
				documents_items: [],
				version: {},
			},
			agreements: {
				isFetching: false,
				admin: {
					isFetching: false,
					data: {}
				},
				legal: {
					isFetching: false,
					data: {}
				}
			},
			dispersions: {
				isFetching: false,
				list: [],
				data: [],
				budgets: {},
				permissions: {}
			},
			phase: {},
			version: {}
		},
		timestamp: Date.now()
	}
}

const projectRequest = () => {
	return {
		type: PROJECT_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const projectFail = (error) => {
	return {
		type: PROJECT_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
}

const projectLoaded = () => {
	return {
		type: PROJECT_LOADED,
		isFetching: false,
		payload: 'loaded',
		timestamp: Date.now()
	}
}

/* project conclusion */
export const projectConclusion = (modality, state, mun = undefined) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			}

			dispatch(projectConclusionRequest());
			dispatch(projectConclusionClear());
			return fetch(`${API2_URL}/projects/register/summary/${modality}/${state}${mun ? '/' + mun : ''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(projectConclusionData(json)),
					error => {
						dispatch(newNotification({
							title: '¡Oh no!',
							content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error),
							type: 'danger'
						}));
						return dispatch(projectConclusionFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
					}
				)
		})
}

export const projectConclusionExport = (modality, state, mun = undefined) => {

	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				}
				let fileName = undefined;
				dispatch(projectConclusionRequest());
				return fetch(`${API2_URL}/projects/register/summary/summary-pdf/${modality}/${state}${mun ? '/' + mun : ''}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							let header = result.headers.get('Content-Disposition', 'attachment')
							fileName = header.match(/filename="(.+)"/)[1];
							return result.blob();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						blob => {
							FileSaver.saveAs(blob, fileName);
							dispatch(projectConclusionLoaded())
						},
						error => {
							dispatch(newNotification({
								title: '¡Oh no!',
								content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error),
								type: 'danger'
							}));
							return dispatch(projectConclusionFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
						}
					)
			})
	}
}

export const projectConclusionSave = (modality, state, mun = undefined, data, event) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				dispatch(projectConclusionRequest());
				let body = new FormData(event);

				_.mapKeys(data, (o, j) => {
					if (o !== undefined) {
						if (!_.isObject(o) && !_.startsWith(o, 'http://')) {
							body.append(j, o);
						} else if (_.isObject(o) && !_.isEmpty(o) && o[0] !== undefined) {
							body.append(j, o[0]);
						}
					}
				});

				let options = {
					headers: {
						'Accept': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: body
				}

				return fetch(`${API2_URL}/projects/register/summary/${modality}/${state}${mun ? '/' + mun : ''}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({
								title: '¡Éxito!',
								content: json.message ? json.message : 'Los cambios se guardaron correctamente',
								type: 'success'
							}));
							return dispatch(projectConclusionData(json));
						},
						error => {
							dispatch(newNotification({
								title: '¡Oh no!',
								content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error),
								type: 'danger'
							}));
							return dispatch(projectConclusionFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}` : error.message) : _.values(error)));
						}
					)
			})
	}
}

const projectConclusionData = (json) => {
	let documents = {};

	if (!_.isEmpty(json.data)) {
		if (!_.isEmpty(json.data.project_version_phase_group)) {
			_.map(json.data.project_version_phase_group.documents, (item) => {
				documents = {
					...documents,
					[item.documentable_subtype]: item.file
				}
			})
		}

		if (json.data.agency) {
			_.map(json.data.agency.documents, (item) => {
				documents = {
					...documents,
					[item.documentable_subtype]: item.file
				}
			})
		}

	}

	return {
		type: PROJECT_CONCLUSION,
		isFetching: false,
		editable: json.editable,
		payload: {
			...json.data,
			documents: documents,
			finished: json.finished ? true : false
		},
		documents_items: json.documents_items,
		revision: json.revision ? {
			...json.revision,
			body: JSON.parse(json.revision.body)
		} : {},
		phase: json.phase,
		permissions: json.permissions,
		version: json.version,
		timestamp: Date.now()
	}
}

const projectConclusionClear = () => {
	return {
		type: PROJECT_CONCLUSION_CLEAR,
		payload: {
			finished: false,
			editable: false,
			data: {},
			revision: {},
			documents_items: []
		},
		phase: {},
		timestamp: Date.now()
	}
}

const projectConclusionLoaded = () => {
	return {
		type: PROJECT_CONCLUSION_LOADED,
		isFetching: false,
		timestamp: Date.now()
	}
}

const projectConclusionRequest = () => {
	return {
		type: PROJECT_CONCLUSION_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const projectConclusionFail = (error) => {
	return {
		type: PROJECT_CONCLUSION_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
}

/* project get all info */
export const fetchCompletProject = (modality, state, mun = undefined) => (dispatch) => {

	dispatch(projectRequest());
	dispatch(projectClear());
	return dispatch(projectOwner(modality, state, mun))
		.then((owner) => {
			if (!_.isEmpty(owner.payload)) {
				return dispatch(fetchProjectAgency(modality, state, mun))
					.then((instance) => {
						if (!_.isEmpty(instance.payload)) {
							return dispatch(projectRegistryData(modality, state, mun))
								.then((registry) => {
									if (registry.payload) {
										return dispatch(fetchProjectExpenses(modality, state, mun))
											.then(expenses => {
												if (!_.isEmpty(expenses.payload)) {
													return dispatch(projectEmployees(modality, state, mun))
														.then((employees) => {
															if (!_.isEmpty(employees.payload)) {
																return dispatch(projectConclusion(modality, state, mun))
																	.then(conclusion => {
																		if (!_.isEmpty(conclusion.payload)) {
																			return dispatch(projectLoaded());
																		} else {
																			return dispatch(projectFail(conclusion.error))
																		}
																	})
															} else {
																return dispatch(projectFail(employees.error))
															}
														})
												} else {
													return dispatch(projectFail(expenses.error))
												}
											})
									} else {
										return dispatch(projectFail(registry.error))
									}
								})
						} else {
							return dispatch(projectFail(instance.error))
						}
					})
			} else {
				return dispatch(projectFail(owner.error))
			}
		})
}


// WEBPACK FOOTER //
// ./src/actions/project.js